module.exports = __webpack_public_path__ + "540250b4237bc00d87ce870bfcdf8830.png";